export const noLayoutContainerStyles = {
  wrapper: {
    height: 'calc(100dvh + 14px)',
    overflow: 'auto',
    textAlign: 'center',
  },
  // A 16px gutter on phones narrower than the form.
  formWrapper: {
    width: 'calc(100% - 32px)',
    maxWidth: 350,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}

export const logoStyles = {
  padding: '3.5% 0 30px 0 ',
}
